import { useNavigate } from "react-router-dom"

import { Button } from "@/components/button"
import { Card } from "@/components/card"
import { FarmingIcon } from "@/domains/icons"

export const NoUniV2Rewards = () => {
  const navigate = useNavigate()

  return (
    <div className="flex flex-col items-center justify-center gap-2 bg-p300 p-4">
      <Card.HeaderIconContainer>
        <FarmingIcon className="h-4 w-4 text-t200" />
      </Card.HeaderIconContainer>
      <div className="flex flex-col items-center justify-center">
        <Card.HeaderTitle>Farming Rewards</Card.HeaderTitle>
        <div className="text-xs text-t200">Farming rewards are earned by staking liquidity into Scale gauges.</div>
      </div>
      <Button
        variant="percentage"
        onClick={() => {
          navigate("/liquidity")
        }}
      >
        Start Staking
      </Button>
    </div>
  )
}
